<template>
	<div>
		<right-panel :datas="resourceId" ref="rightPanel" @onClose="onCloseForm" @onSubmit="onSubmitForm">
			<div slot="header">
				<translate v-if="!moreForm.moreSet">Basic information</translate>
				<translate v-if="moreForm.moreSet">SQL Application</translate>
			</div>
			<div slot="content" class="wrapper-padding">
				<el-form ref="addForm" :model="addForm" :rules="rules" label-width="120px" v-if="!moreForm.moreSet">
					<el-form-item :label="attrText.resourceName" prop="name">
						<el-input v-model.trim="addForm.name" :disabled="parentId"></el-input>
					</el-form-item>
					<el-form-item :label="attrText.innerIp">
						<el-input v-model.trim="addForm.ipAddress"></el-input>
					</el-form-item>
					<el-form-item :label="attrText.port">
						<el-input v-model.trim="addForm.port"></el-input>
					</el-form-item>
					<el-form-item v-if="addForm.os === 'oracle'" :label="attrText.connectIdentifierType" prop="serviceNameType">
						<el-select v-model="addForm.serviceNameType" :disabled="parentId">
							<el-option label="Service Name" value="service_name"></el-option>
							<el-option label="SID" value="sid"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="addForm.os === 'oracle'" :label="attrText.connectIdentifier" prop="serviceName">
						<el-input v-model.trim="addForm.serviceName"></el-input>
					</el-form-item>
					<el-form-item :label="attrText.database" prop="database" style="word-wrap: break-word">
						<el-input v-model.trim="addForm.database"></el-input>
					</el-form-item>
					<el-form-item :label="attrText.os">
						<span v-if="addForm.os === 'mssql'">SQL Server</span>
						<span v-else-if="addForm.os === 'postgresql'">PostgreSQL</span>
						<span v-else-if="addForm.os === 'oracle'">Oracle</span>
						<span v-else>MySQL</span>
					</el-form-item>
					<el-form-item :label="attrText.userName">
						<div style="display: flex; align-items: center">
							<el-input v-model="addForm.username" :disabled="disEditUsername"></el-input>
							<el-button
								type="text"
								:disabled="parentId"
								@click="
									disEditUsername = !disEditUsername
									addForm.username = databaseObj.username
								">
								<translate v-if="disEditUsername">Change</translate>
								<translate v-else>Cancel</translate>
							</el-button>
						</div>
					</el-form-item>
					<el-form-item :label="attrText.password">
						<div style="display: flex; align-items: center">
							<el-input v-model="addForm.password" type="password" placeholder="如无需修改密码，则密码留空。" :disabled="disEditPassword"></el-input>
							<el-button
								type="text"
								:disabled="parentId"
								@click="
									disEditPassword = !disEditPassword
									addForm.password = ''
								">
								<translate v-if="disEditPassword">Change</translate>
								<translate v-else>Cancel</translate>
							</el-button>
						</div>
					</el-form-item>
					<a class="more" @click="moreForm.moreSet = true">
						<i class="fa fa-plus-square-o fa-lg"></i>
						<translate>More</translate>
					</a>
				</el-form>
				<!--更多设置-->
				<div class="database-wrapper">
					<el-form ref="form" :model="moreForm" label-width="120px" v-if="moreForm.moreSet" :show-message="false">
						<!-- <el-form-item :label="attrText.sqlInterception" v-if="!parentId">
							<el-radio class="radio" v-model="moreForm.sqlInterception" label="1">
								<translate>on</translate>
							</el-radio>
							<el-radio class="radio" v-model="moreForm.sqlInterception" label="0">
								<translate>off</translate>
							</el-radio>
						</el-form-item> -->

						<!-- 拦截指令 -->
						<el-form-item :label="attrText.interceptionCommand" v-if="!parentId">
							<el-select class="inter-select" v-model="moreForm.action" :placeholder="attrText.select">
								<el-option v-for="(item, index) in moreForm.interceptsCommand" :key="index" :label="item[0]" :value="item[0]"></el-option>
							</el-select>
							<el-row>
								<el-col :span="19">
									<el-input v-model="moreForm.cellName" :placeholder="attrText.tableName" :disabled="addTable"></el-input>
								</el-col>
								<el-col :span="3" :offset="2">
									<el-button type="text" :disabled="moreForm.action === ''" @click="addCommand()">
										<translate>Add</translate>
									</el-button>
								</el-col>
							</el-row>
							<div class="table-command">
								<el-table :data="moreForm.interception" stripe :empty-text="attrText.notCommand" style="width: 100%; margin-top: 10px">
									<el-table-column prop="op" :label="attrText.command"></el-table-column>
									<el-table-column prop="table" :label="attrText.tableName">
										<template scope="scope">
											{{ scope.row.table ? scope.row.table : 'All' }}
										</template>
									</el-table-column>
									<el-table-column :label="attrText.action" width="100">
										<template scope="scope">
											<el-button type="text" @click="removeCommand(scope.$index)" :disabled="moreForm.setRadio === '0'">
												<translate>Remove</translate>
											</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-form-item>
						<!-- SQL审批人 -->
						<el-form-item :label="attrText.sqlApprover">
							<el-radio class="radio" v-model="moreForm.sqlApprover" label="1" :disabled="moreForm.setRadio === '0'">
								<translate>on</translate>
							</el-radio>
							<el-radio class="radio" v-model="moreForm.sqlApprover" label="0" :disabled="moreForm.setRadio === '0'">
								<translate>off</translate>
							</el-radio>
						</el-form-item>
						<!-- 审批人 -->
						<el-form-item :label="attrText.approver">
							<el-row>
								<el-col :span="19">
									<el-select v-model="moreForm.name" :placeholder="attrText.selected" :disabled="moreForm.sqlApprover === '0'">
										<el-option v-for="(item, index) in moreForm.nameList" :label="`${item.name}(${item.account})`" :value="item.name" :key="index"></el-option>
									</el-select>
								</el-col>
								<el-col :span="3" :offset="2">
									<el-button type="text" :disabled="moreForm.sqlApprover === '0'" @click="addApprover()">
										<translate>Add</translate>
									</el-button>
								</el-col>
							</el-row>
							<el-table :data="moreForm.approver" stripe :empty-text="attrText.noApprover" style="width: 100%; margin-top: 10px">
								<el-table-column prop="name" :label="attrText.approver"></el-table-column>
								<el-table-column :label="attrText.action" width="100">
									<template scope="scope">
										<el-button type="text" @click="removeApprover(scope.$index)" :disabled="moreForm.sqlApprover === '0'">
											<translate>Remove</translate>
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-form-item>

						<!-- SQL指令告警 -->
						<el-form-item :label="attrText.sqlAlarmIntruct">
							<el-radio class="radio" v-model="moreForm.sqlAlarmIntruct" label="1">
								<translate>on</translate>
							</el-radio>
							<el-radio class="radio" v-model="moreForm.sqlAlarmIntruct" label="0">
								<translate>off</translate>
							</el-radio>
						</el-form-item>
						<!-- 告警指令 -->
						<el-form-item :label="attrText.alarmInstruction" v-if="!parentId">
							<el-select class="inter-select" v-model="moreForm.alarmAction" :placeholder="attrText.select" :disabled="moreForm.sqlAlarmIntruct === '0'">
								<el-option v-for="(item, index) in moreForm.interceptsCommand" :key="index" :label="item[0]" :value="item[0]"></el-option>
							</el-select>
							<el-row>
								<el-col :span="19">
									<el-input v-model="moreForm.alarmCellName" :placeholder="attrText.tableName" :disabled="moreForm.sqlAlarmIntruct === '0'"></el-input>
								</el-col>
								<el-col :span="3" :offset="2">
									<el-button type="text" :disabled="moreForm.sqlAlarmIntruct === '0'" @click="addAlarmCommand()">
										<translate>Add</translate>
									</el-button>
								</el-col>
							</el-row>
							<div class="table-command">
								<el-table :data="moreForm.alarmInterception" stripe :empty-text="attrText.notAlarmCommand" style="width: 100%; margin-top: 10px">
									<el-table-column prop="op" :label="attrText.command"></el-table-column>
									<el-table-column prop="table" :label="attrText.tableName">
										<template scope="scope">
											{{ scope.row.table ? scope.row.table : 'All' }}
										</template>
									</el-table-column>
									<el-table-column :label="attrText.action" width="100">
										<template scope="scope">
											<el-button type="text" @click="removeAlarmCommand(scope.$index)" :disabled="moreForm.sqlAlarmIntruct === '0'">
												<translate>Remove</translate>
											</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-form-item>
						<!-- 通知人 -->
						<el-form-item :label="attrText.notifier">
							<el-row>
								<el-col :span="19">
									<el-select v-model="moreForm.notifier" :placeholder="attrText.selected" :disabled="moreForm.sqlAlarmIntruct === '0'">
										<el-option v-for="(item, index) in moreForm.nameList" :label="`${item.name}(${item.account})`" :value="item.name" :key="index"></el-option>
									</el-select>
								</el-col>
								<el-col :span="3" :offset="2">
									<el-button type="text" :disabled="moreForm.sqlAlarmIntruct === '0'" @click="addNotifier()">
										<translate>Add</translate>
									</el-button>
								</el-col>
							</el-row>
							<el-table :data="moreForm.notifierList" stripe :empty-text="attrText.noNotifier" style="width: 100%; margin-top: 10px">
								<el-table-column prop="name" :label="attrText.notifier"></el-table-column>
								<el-table-column :label="attrText.action" width="100">
									<template scope="scope">
										<el-button type="text" @click="removeNotifier(scope.$index)" :disabled="moreForm.sqlAlarmIntruct === '0'">
											<translate>Remove</translate>
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div slot="footer" class="detail-btn">
				<el-button type="primary" @click="onSubmitForm()" :disabled="(moreForm.sqlApprover === '1' && moreForm.approver.length === 0) || (moreForm.sqlAlarmIntruct === '1' && (moreForm.notifierList.length === 0 || moreForm.alarmInterception.length === 0))">
					<translate>Save</translate>
				</el-button>
				<el-button @click="onCloseForm()">
					<translate>Cancel</translate>
				</el-button>
			</div>
		</right-panel>
	</div>
</template>

<script>
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
import { Utils } from '../../../config'
export default {
	name: 'ClusterDatabaseSetting',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			resourceId: null,
			parentId: null,
			databaseObj: null,
			addForm: {
				name: '',
				database: '',
				ipAddress: '',
				os: '',
				username: '',
				port: '',
				password: '',
				serviceName: '',
				serviceNameType: 'service_name',
			},
			disEditUsername: true,
			disEditPassword: true,
			moreForm: {
				interceptsCommand: [],
				moreSet: false,
				sqlInterception: '',
				action: '',
				cellName: '',
				interception: [],
				sqlApprover: '',
				approver: [],
				name: '',
				nameList: [],
				sqlAlarmIntruct: '',
				alarmAction: '',
				alarmCellName: '',
				alarmInterception: [],
				notifier: '',
				notifierList: [],
			},
			isHave: {
				action: [],
				cellName: false,
			},
			isHave_alarm: {
				action: [],
				cellName: false,
			},
			rules: {
				name: [{ required: true, message: this.$gettext('Please input the resource name'), trigger: 'change' }],
				database: [{ required: true, message: this.$gettext('Please input the databaseName'), trigger: 'change' }],
				serviceNameType: [{ required: true, message: this.$gettext('Please select the connection identifier type'), trigger: 'change' }],
				serviceName: [{ required: true, message: this.$gettext('Please input the Service Name / SID'), trigger: 'change' }],
			},
		}
	},
	computed: {
		attrText() {
			return this.translateText()
		},
		addTable() {
			let command = this.moreForm.interceptsCommand.find((action) => {
				return action[0] === this.moreForm.action
			})
			if (command) {
				return !command[1]
			} else {
				return true
			}
		},
		alarmAddTable() {
			let command = this.moreForm.interceptsCommand.find((action) => {
				return action[0] === this.moreForm.alarmAction
			})
			if (command) {
				return !command[1]
			} else {
				return true
			}
		},
	},
	created() {
		setTimeout(() => {
			this.onSetDatabase()
		}, 301)
	},
	methods: {
		// 提取翻译文本
		translateText() {
			return {
				resourceName: this.$gettext('Resource name'),
				database: this.$gettext('Database'),
				connectIdentifier: this.$gettext('Service Name / SID'),
				connectIdentifierType: this.$gettext('Connection identifier type'),
				innerIp: this.$gettext('IP/Connection Address'),
				os: this.$gettext('Type'),
				userName: this.$gettext('Username'),
				tableName: this.$gettext('Table Name'),
				port: this.$gettext('Port'),
				password: this.$gettext('Password'),
				sqlInterception: this.$gettext('SQL Interception'),
				interceptionCommand: this.$gettext('Interception Command'),
				command: this.$gettext('Command'),
				action: this.$gettext('Action'),
				sqlApprover: this.$gettext('SQL Approver'),
				approver: this.$gettext('Approver'),
				select: this.$gettext('select'),
				noApprover: this.$gettext('Not set approver'),
				notCommand: this.$gettext('Not add block command'),
				sqlAlarmIntruct: this.$gettext('SQL Alarm instruction'),
				alarmInstruction: this.$gettext('Alarm instruction'),
				notifier: this.$gettext('Notifier'),
				noNotifier: this.$gettext('Not set notifier'),
				notAlarmCommand: this.$gettext('Not set up alarm command'),
			}
		},
		// 获取数据库拦截指令列表
		getInterceptsCommand() {
			let params = {
				type: this.addForm.os,
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_INTERCEPTS_COMMADN, params).then((res) => {
				this.moreForm.interceptsCommand = res.result
			})
		},
		// 获取数据库资源详情
		onSetDatabase() {
			this.getSafeApprover()
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_RESOURCE_DETAIL, this.resourceId).then((res) => {
				console.log(res, '获取数据库资源详情')
				this.databaseObj = res
				this.parentId = res.parent_id
				this.addForm = Object.assign({}, this.addForm, {
					name: res.name,
					ipAddress: res.ip_address,
					database: res.databases.join(';'),
					serviceName: res.service_name || '',
					serviceNameType: res.service_name_type || 'service_name',
					username: res.username,
					os: res.os,
					port: res.port,
				})
				this.moreForm = Object.assign({}, this.moreForm, {
					interception: res.block_pattern ? JSON.parse(res.block_pattern) : [],
					alarmInterception: res.notice_pattern ? JSON.parse(res.notice_pattern) : [],
					sqlApprover: res.status !== 2 ? '0' : '1',
					sqlAlarmIntruct: res.notice_status ? '1' : '0',
					sqlInterception: res.status === 2 ? '1' : '0',
					approver: res.approve_accounts ? res.approve_accounts : [],
					notifierList: res.notice_accounts ? res.notice_accounts : [],
				})
				this.getInterceptsCommand()
			})
		},
		// 获取安全模式审核人列表
		getSafeApprover() {
			let params = {
				results_per_page: Utils.config.maxPageSize,
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_SAFE_APPROVER, params).then((res) => {
				this.moreForm.nameList = res.objects
			})
		},
		// 添加指令
		addCommand() {
			if (this.moreForm.action !== '') {
				this.isHave.action = []
				this.isHave.cellName = false
				if (this.moreForm.interception.length === 0) {
					if (this.moreForm.cellName === '') {
						this.moreForm.interception.push({ op: this.moreForm.action })
					} else {
						this.moreForm.interception.push({ op: this.moreForm.action, table: this.moreForm.cellName })
					}
				} else {
					this.moreForm.interception.forEach((item) => {
						if (item.op === this.moreForm.action) {
							this.isHave.action.push(item)
						}
					})
					if (this.isHave.action.isEmpty()) {
						if (this.moreForm.cellName === '') {
							this.moreForm.interception.push({ op: this.moreForm.action })
						} else {
							this.moreForm.interception.push({ op: this.moreForm.action, table: this.moreForm.cellName })
						}
					} else {
						if (this.moreForm.cellName === '') {
							this.isHave.action.forEach((item) => {
								if (!item.table) {
									this.isHave.cellName = true
								}
							})
							if (!this.isHave.cellName) {
								this.moreForm.interception.push({ op: this.moreForm.action })
							}
						} else {
							this.isHave.action.forEach((item) => {
								if (item.table === this.moreForm.cellName) {
									this.isHave.cellName = true
								}
							})
							if (!this.isHave.cellName) {
								this.moreForm.interception.push({ op: this.moreForm.action, table: this.moreForm.cellName })
							}
						}
					}
				}
				// 添加完后清空表名称
				this.moreForm.cellName = ''
			}
		},
		// 移除指令
		removeCommand(val) {
			this.moreForm.interception.splice(val, 1)
		},
		// 添加告警指令
		addAlarmCommand() {
			if (this.moreForm.alarmAction !== '') {
				this.isHave_alarm.action = []
				this.isHave_alarm.cellName = false
				if (this.moreForm.alarmInterception.length === 0) {
					if (this.moreForm.alarmCellName === '') {
						this.moreForm.alarmInterception.push({ op: this.moreForm.alarmAction })
					} else {
						this.moreForm.alarmInterception.push({ op: this.moreForm.alarmAction, table: this.moreForm.alarmCellName })
					}
				} else {
					this.moreForm.alarmInterception.forEach((item) => {
						if (item.op === this.moreForm.alarmAction) {
							this.isHave_alarm.action.push(item)
						}
					})
					if (this.isHave_alarm.action.isEmpty()) {
						if (this.moreForm.alarmCellName === '') {
							this.moreForm.alarmInterception.push({ op: this.moreForm.alarmAction })
						} else {
							this.moreForm.alarmInterception.push({ op: this.moreForm.alarmAction, table: this.moreForm.alarmCellName })
						}
					} else {
						if (this.moreForm.alarmCellName === '') {
							this.isHave_alarm.action.forEach((item) => {
								if (!item.table) {
									this.isHave_alarm.cellName = true
								}
							})
							if (!this.isHave_alarm.cellName) {
								this.moreForm.alarmInterception.push({ op: this.moreForm.alarmAction })
							}
						} else {
							this.isHave_alarm.action.forEach((item) => {
								if (item.table === this.moreForm.alarmCellName) {
									this.isHave_alarm.cellName = true
								}
							})
							if (!this.isHave_alarm.cellName) {
								this.moreForm.alarmInterception.push({ op: this.moreForm.alarmAction, table: this.moreForm.alarmCellName })
							}
						}
					}
				}
				// 添加完后清空表名称
				this.moreForm.alarmCellName = ''
			}
		},
		// 删除告警指令
		removeAlarmCommand(val) {
			this.moreForm.alarmInterception.splice(val, 1)
		},
		// 添加审核人
		addApprover() {
			if (this.moreForm.name !== '') {
				var have = false
				this.moreForm.approver.forEach((item) => {
					if (item.name === this.moreForm.name) {
						have = true
					}
				})
				if (!have) {
					this.moreForm.nameList.forEach((item) => {
						if (item.name === this.moreForm.name) {
							this.moreForm.approver.push(item)
						}
					})
				}
			}
		},
		// 删除审核人
		removeApprover(val) {
			this.moreForm.approver.splice(val, 1)
			this.$notify({
				type: 'success',
				message: this.$gettext('Remove successfully!'),
			})
		},
		// 添加通知人
		addNotifier() {
			if (this.moreForm.notifier !== '') {
				var have = false
				this.moreForm.notifierList.forEach((item) => {
					if (item.name === this.moreForm.notifier) {
						have = true
					}
				})
				if (!have) {
					this.moreForm.nameList.forEach((item) => {
						if (item.name === this.moreForm.notifier) {
							this.moreForm.notifierList.push(item)
						}
					})
				}
			}
		},
		// 删除通知人
		removeNotifier(val) {
			this.moreForm.notifierList.splice(val, 1)
			this.$notify({
				type: 'success',
				message: this.$gettext('Remove successfully!'),
			})
		},
		// 确定修改资源
		onSubmitForm() {
			console.log('moreForm', this.moreForm)
			let addApprover = this.moreForm.approver.map((item) => item.id).join(',')
			let addNotifier = this.moreForm.notifierList.map((item) => item.id).join(',')
			let params = {
				id: this.resourceId,
				data: {
					data: {
						name: this.addForm.name,
						ip_address: this.addForm.ipAddress,
						os: this.addForm.os,
						port: Number(this.addForm.port),
						databases: [],
						service_name: this.addForm.os === 'oracle' ? this.addForm.serviceName : null,
						service_name_type: this.addForm.os === 'oracle' ? this.addForm.serviceNameType : null,
						username: this.addForm.username || null,
						password: this.addForm.password || null,
						status: this.moreForm.sqlApprover === '1' ? 2 : 1,
						notice_status: this.moreForm.sqlAlarmIntruct === '1' ? 1 : 0,
						block_pattern: JSON.stringify(this.moreForm.interception),
						notice_pattern: JSON.stringify(this.moreForm.alarmInterception),
					},
				},
			}
			// this.addForm.username.split(';').forEach((el) => {
			// 	if (el && el.trim()) {
			// 		params.data.data.username.push(el.trim())
			// 	}
			// })
			this.addForm.database.split(';').forEach((el) => {
				if (el && el.trim()) {
					params.data.data.databases.push(el.trim())
				}
			})
			if (this.moreForm.sqlApprover === '1') {
				params.data.data.approver_accounts = addApprover
			}
			if (this.moreForm.sqlAlarmIntruct === '1') {
				params.data.data.notice_accounts = addNotifier
			}
			if (!this.moreForm.moreSet) {
				this.$refs['addForm'].validate((valid) => {
					if (valid) {
						this.$store.dispatch(STORE_CONST.CLUSTER.PATCH_RESOURCE, params).then((res) => {
							this.$notify({
								type: 'success',
								message: this.$gettext('Change successfully!'),
							})
							this.$emit('callback')
							this.onCloseForm()
						})
					} else {
						return false
					}
				})
			} else {
				this.$store.dispatch(STORE_CONST.CLUSTER.PATCH_RESOURCE, params).then((res) => {
					this.$notify({
						type: 'success',
						message: this.$gettext('Change successfully!'),
					})
					this.$emit('callback')
					this.onCloseForm()
				})
			}
		},
		// 关闭修改集群
		onCloseForm() {
			this.connects = null
			this.$emit('onClosePanel')
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.resourceId) {
					this.resourceId = null
					setTimeout(() => {
						this.resourceId = this.items
					}, 300)
				} else {
					this.resourceId = this.items
				}
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../../assets/css/variable';

.more {
	margin-left: 20px;
	cursor: pointer;
	span {
		margin-left: 10px;
	}
	&:hover {
		color: $mainColor;
	}
}

.table-command {
	.el-table__body-wrapper {
		overflow: hidden;
	}
}

.el-radio {
	margin-right: 30px;
}

.el-radio + .el-radio {
	margin-top: 0;
	margin-left: 0;
}

.el-radio__inner::after {
	width: 10px;
	height: 10px;
}

p {
	line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// cluster-database-setting.vue?267f213c